import React from "react";
import styled, { css } from "styled-components";
import settings from "@src/settings";
import { Props } from "./";
import { down } from "styled-breakpoints";
import { useBreakpoint } from "styled-breakpoints/react-styled";

export const TailObj = styled.svg<{ forSm?: boolean }>`
	${(props) =>
		props.forSm
			? css`
					display: none;
			  `
			: css`
					display: block;
			  `}
	${down("xs")} {
		${(props) =>
			props.forSm
				? css`
						display: block;
				  `
				: css`
						display: none;
				  `}
	}
`;

export const Frame = styled.div<Props>`
	position: absolute;
	&:before,
	&:after {
		content: "";
		display: block;
		position: absolute;
		background-color: ${settings.color.main};
	}
	${TailObj} {
		position: absolute;
		${(props) =>
			props.direction == "fromRight"
				? css`
						top: 50%;
						right: ${useBreakpoint(down("xs")) ? -1 : 0}px;
						transform: translate(100%, -50%);
				  `
				: props.direction == "fromLeft"
				? css`
						top: 50%;
						left: ${useBreakpoint(down("xs")) ? -1 : 0}px;
						transform: translate(-100%, -50%) rotate(180deg);
				  `
				: props.direction == "fromTop"
				? css`
						left: 50%;
						top: ${useBreakpoint(down("xs")) ? -1 : 0}px;
						transform: translate(-50%, -100%) rotate(-90deg);
				  `
				: props.direction == "fromBottom" &&
				  css`
						left: 50%;
						bottom: ${useBreakpoint(down("xs")) ? -1 : 0}px;
						transform: translate(-50%, 100%) rotate(90deg);
				  `}
	}
	${(props) =>
		props.direction == "fromRight"
			? css`
					height: 100%;
					right: 5px;
					&:before,
					&:after {
						width: 5px;
					}
					&:before {
						top: 0;
						bottom: calc(50% + ${useBreakpoint(down("xs")) ? 7 : 14}px);
						right: 0;
						transform: translateX(100%);
					}
					&:after {
						bottom: 0;
						top: calc(50% + ${useBreakpoint(down("xs")) ? 7 : 14}px);
						right: 0;
						transform: translateX(100%);
					}
			  `
			: props.direction == "fromLeft"
			? css`
					height: 100%;
					left: 5px;
					&:before,
					&:after {
						width: 5px;
					}
					&:before {
						top: 0;
						bottom: calc(50% + ${useBreakpoint(down("xs")) ? 7 : 14}px);
						left: 0;
						transform: translateX(-100%);
					}
					&:after {
						bottom: 0;
						top: calc(50% + ${useBreakpoint(down("xs")) ? 7 : 14}px);
						left: 0;
						transform: translateX(-100%);
					}
			  `
			: props.direction == "fromTop"
			? css`
					width: 100%;
					top: 5px;
					&:before,
					&:after {
						height: 5px;
					}
					&:before {
						left: 0;
						right: calc(50% + ${useBreakpoint(down("xs")) ? 7 : 14}px);
						top: 0;
						transform: translateY(-100%);
					}
					&:after {
						right: 0;
						left: calc(50% + ${useBreakpoint(down("xs")) ? 7 : 14}px);
						top: 0;
						transform: translateY(-100%);
					}
			  `
			: props.direction == "fromBottom" &&
			  css`
					width: 100%;
					bottom: 5px;
					&:before,
					&:after {
						height: 5px;
					}
					&:before {
						left: 0;
						right: calc(50% + ${useBreakpoint(down("xs")) ? 7 : 14}px);
						bottom: 0;
						transform: translateY(100%);
					}
					&:after {
						right: 0;
						left: calc(50% + ${useBreakpoint(down("xs")) ? 7 : 14}px);
						bottom: 0;
						transform: translateY(100%);
					}
			  `}
`;
